import { DISPLAY_MODE_CASE_DETAILS } from '../components/Assignment/SelectionDetails';
const appraiser = {
  fetchingAppraiserList: true,
  appraiserList: {},
  fetchingAppraiserProfile: true,
  appraiserProfile: {},
  fetchingAppraiserManagers: false,
  appraiserManagers: {},
  certificateList: [],
  fetchingCertificateList: false,
  designationList: [],
  fetchingDesignationList: false,
  stateList: [],
  fetchingStateList: false,
  payPeriodSummary: null,
  fetchingPayPeriodSummary: true,
  counties: null,
  fetchingCounties: false,
  appraiserCountiesList: null, // Array of { appraiserId, counties }, used to load county coverage for multiple appraisers at a time
  fetchingAppraiserCountiesList: false,
  fetchingExclusionSearchResults: false,
  exclusionSearchResults: {},
  minimalAppraiserList: [],
  fetchingMinimalAppraiserList: false,
  valuationCoordinators: [],
  fetchingValuationCoordinators: false,
  valuationDirectors: [],
  fetchingValuationDirectors: false,
};

const fieldRep = {
  isFetchingFieldReps: false,
  fieldRepsDetailed: null,
  fieldRepsBasic: null,
  isFetchingAllTeamLeaders: false,
  allTeamLeaders: [],
  isFetchingFieldDevelopmentManagers: false,
  fieldRepDevelopmentManagers: [],
  fieldRepsBasicByCase: null,
  fieldRepManagers: [],
  isFetchingFieldRepManagers: false,
  timeLogSummaryList: [],
  isFetchingTimeLogSummary: false,
  fetchingExclusionSearchResults: false,
  exclusionSearchResults: {},
};

const broker = {
  fetchingBrokerCaseHeader: true,
  brokerCaseHeader: {},
  fetchingBrokerCaseHistory: true,
  brokerCaseHistory: {},
  fetchingWaiverDetails: true,
  waiverDetails: {}
};

const brokerRegistration = {
  isSubmitting: false,
  success: false,
  username: "",
  isFetchingCompanies: false,
  availableCompanies: [],
};

const brokerMaintenanceSettings = {
  isFetchingSettings: false,
  isSubmittingSettings: false,
  success: false,
  brokerSettings: {},
};

const caseForms = {
  fetchingCaseFormsList: true,
  caseFormsList: [],
  fetchingHeader: false,
  caseHeader: {},
  fetchingPrivateNotes: true,
  privateNotes: {},
  fetchingFiles: true,
  files: {},
  fetchingHistory: true,
  caseHistory: {},
  historyList: {},
  fetchingPhotos: false,
  photos: {},
  fetchingSketches: true,
  sketches: [],
  allCaseFormsList: [],
  availCaseFormsList: [],
  manageForms: false,
  fetchingAllCaseForms: false,
  compPhotoMetadata: [],

  pnxValidation: {
    fetchingResult: false,
    validateSuccess: false,
    validationMessages: [],
    validationResults: []
  },
  validating: false,
  submitCallback: () => { },
  allCardsExpanded: null,

  workflowStatus: {},
  fetchingWorkflowStatus: false,
  workflowActionInProgress: 0,
  workflowMonitor: {
    controlNumber: 0,
    display: false,
    workingMessage: "",
    started: false,
    finished: false,
    validation: {
      required: false,
      started: false,
      finished: false,
      success: false
    },
    workflowCall: {
      initialWorkflowStatusId: 0,
      method: "",
      workflow: "",
      reasonText: "",
      started: false,
      finished: false,
      success: false
    }
  },
  publicPropertyRecord: {},
  isFetchingPublicPropertyRecord: false,
  caseAttributes: [],
  isFetchingCaseAttributes: false,
  updatingCaseHeader: false,
  isFetchingAppraisalFormData: false,
  isSavingAppraisalFormData: false,
  dataForAppraisalForm: null,
  isFetchingPNXFormExportData: false,
  isSavingPNXFormExportData: false,
  dataForPNXFormExportData: null,
  fetchingCaseHeaderV2: false,
  caseHeaderV2: null,
};

const comparable = {
  fetchingPropmixSsoUrl: false,
  comparable: {},
  fetchingComparableDetails: false,
  comparableDetails: {},
  gridData: {},
  fetchingGridData: false,
  postingGridData: false,
};

const validation = {
  dirtyValidationIssues: true,
  fetchingValidationIssues: true,
  validationIssues: [],
  fetchingFormIssues: true,
  formIssues: {},
  fetchingValidationStatus: false,
  validationStatus: [],
  gaarResults: {},
  fetchingGaarResults: false,
};

const caseDetails = {
  fetchingCase: true,
  caseInfo: {},
  fetchingNotes: true,
  caseNotes: {},
  fetchingPolicy: true,
  policyInfo: {},
  assignableAppraisers: {},
  isFetchingAssignableAppraisers: false,
  isChangingAppraiserAssigned: false,
  caseConversionOptions: [],
  assignAppraiserAudit: false,
};

const caseTimeLog = {
  fetching: true,
  timeLog: {},
  timeLogs: [],
  isFetchingTimeLogs: false,
  payPeriods: [],
  isFetchingPayPeriods: true,
  approvedPayPeriod: {},
  payPeriodUsers: [],
  isFetchingPayPeriodUsers: true,
  isUpdatingTimeLogs: false,
  isDeletingTimeLogs: false,
};

const dashboard = {
  fetchingCaseList: true,
  caseList: {},
  fetchingProfile: true,
  profile: {},
  fetchingNotifications: true,
  notifications: [],
  fetchingStatistics: true,
  statistics: {},
  fetchingGridFilters: true,
  fetchingGridFilterMenus: false,
  gotInitialGridFilterMenus: false,
  gotInitialGridFilters: false,
  gridFilterMenus: {},
  gridFilters: [
    { term: "status", title: "All Open", code: "allnotcompleted", id: "" },
    { term: "appraiser", title: "All Appraisers", code: "all", id: "" },
    { term: "date", title: "Last 30 Days", code: "last30", id: "" },
    { term: "customer", title: "All Customers", code: "all", id: "" }
  ]
};

const qaAppraisalRejections = {
  list: [],
  isFetching: false
};

const search = {
  lastSearchTime: 0,
  searchText: "",
  items: {},
  isFetching: false
};

const sidebar = {
  items: [],
  isFetching: false,
  expanded: true,
  activeModule: null
};

const headerDefinitions = {
  buttons: [],
  topMenuTitle: null,
  dropdownTitle: null
};

const popoutWindows = {
  active: [],
};

const display = {
  resizeRequired: false
};

const snackbar = {
  toasts: [],
  autohide: true,
  className: "error",
  toastsQueue: []
};

const user = {
  profile: {},
  isFetching: false,
  maintenanceSections: [],
  isFetchingMaintenanceSections: true,
  internetUserList: [],
  isFetchingInternetUserList: false,
  loginStatistics: null,
  isFetchingLoginStatistics: false,
  internetUserId: null,
  internetUser: {},
  isFetchingInternetUser: false,
  isFetchingAllCustomersList: false,
  allCustomers: [],
  isFetchingAllSurveyTypesList: false,
  allSurveyTypes: [],
  updatingUser: false,
  isFetchingAllRightsList: false,
  allRights: [],
  isFetchingAllRolesList: false,
  allRoles: [],
  isFetchingAllMajorCompanies: false,
  allMajorCompanies: [],
  updatingUserInfo: false,
  triedLogin: false,
  activeClock: {} as { clockInDate?: Date },
  midnight: null,
  timeClockByPayPeriod: [],
  isFetchingTimeClockByPayPeriod: true,
  isFetchingActiveClock: true,
  isAddingTimeClock: false,
  isDeletingTimeClock: false,
  isUpdatingTimeClock: false,
  employees: [],
  isFetchingEmployees: false,
  isApprovingPayPeriod: false,
  employeeDetails: {},
  isFetchingEmployeeDetails: false,
  isCreatingUser: false,
  returnUrl: "",
  redirect: {},
  willLogOut: false,
  trainingSections: [],
  fetchingTrainingSections: false,
  isFetchingUnderwriters: false,
  userUnderwriters: [],
  isFetchingAuthorizedUnderwriters: false,
  authorizedUnderwriters: [],
};

const twoFactor = {
  authResult: {}
};

const webOrder = {
  confirmationNumber: null,
  loanNumber: null,
  lastLoanNumber: null,
  lenders: {
    isFetching: false,
    lenderList: []
  },
  reportType: {
    isFetching: false,
    availReportTypes: [],
    selectedReportType: null,
    billingAmount: null
  },
  appointmentHolidays: {
    isFetching: false,
    holidaysList: []
  },
  fetchingCheckout: true,
  savingCheckout: false,
  cancelingCheckout: false,
  checkout: {},
  billingAmount: null,
};

const region = {
  isFetchingStates: true,
  states: [],
  isFetchingCountiesByState: false,
  countiesByState: [],
  isFetchingAllCounties: false,
  allCounties: [],
  isFetchingCountyBoundaries: false,
  countyBoundaries: {}, //an object keyed on county boundary id for fast lookups
  isFetchingServiceRegions: false,
  serviceRegions: [], // array of 'ServiceRegionSlim': [ { name: string, id: integer }, ... ]
};

const appraiserManagerAssignRegion = {
  isFetchingAssignedStates: false,
  assignedStates: {},
  isFetchingAssignedCounties: false,
  assignedCounties: {}
};

const employee = {
  isFetchingEmployeeList: true,
  employeeList: [],
  fetchingBusOpsDirectors: false,
  busOpsDirectors: [],
  fetchingBusOpsManagers: false,
  busOpsManagers: [],
  fetchingFieldDevelopmentManagers: false,
  fieldDevelopmentManagers: [],
  isFetchingLenderLogisticsManagers: false,
  lenderLogisticsManagers: [],
  isFetchingFieldOperationsManagers: false,
  fieldOperationsManagers: [],
  fetchingSchedulingUsers: false,
  schedulingUsers: [],
  isFetchingCustomerExperienceManagers: false,
  isFetchingCustomerExperienceDirectors: false,
  customerExperienceManagers: [],
  customerExperienceDirectors: [],
};

const assignment = {
  isFetchingCasesWithAppointments: false,
  assignedCasesWithAppts: null,
  config: { isFetching: false },
  assignStatus: { assigning: false, success: null },
  unassignStatus: { unassigning: false, success: null },
  isFetchingCases: false,
  cases: null,
  isFetchingCaseDetails: false,
  caseDetails: null,
  isFetchingInspectorDetails: false,
  inspectorDetails: null,
  isFetchingInspectorPayPeriodSummary: false,
  inspectorPayPeriodSummary: null,
  isFetchingAssignedCases: false,
  assignedCases: null,
  isFetchingInspectors: false,
  inspectors: null,
  isFetchingZipCodes: false,
  zipCodes: null,
  appraisalCaseCount: null,
  insuranceCaseCount: null,
  pinTypesSelected: [],
  countiesSelected: [],
  daysOldOptionSelected: { value: null, label: "All Ordered" },
  daysTillDueSelected: { value: null, label: "All Due" },
  extraFiltersSelected: [],
  caseIdFilter: null,
  showExtraDetails: false,
  selectionDetailsMode: DISPLAY_MODE_CASE_DETAILS,
  selectedInspector: null,
  isFRGeoCoverageMode: null,
  tempFRGeoServiceRegion: null,
};

const filters = {
  clientSideFilters: {},
  clearFilters: 0
};

const preferences = {
  /*
    preferences will be filled in dynamically
    example if loading preference for stateList
    preferences.stateList = {
        isFetching: false,
        value: ['NY','CA']
    };
  */
};

const changeStatus = {
  processingStatusChange: true,
};

const qualityAssurance = {
  // holds the id to the timer that we are running so we can stop it later
  timerId: null as number, // "as number" so it gets typed as a number
  timerPingIntervalSeconds: null as number,
  requestSuccessful: false,
  qaCase: {
    controlIdNumber: 0,
    qaQueueId: 0,
    qaQueueTypeId: 0,
    caseInfo: {
      primaryStatus: "",
      secondaryStatus: "",
      customerNumber: 0,
      customerName: "",
      originalInspectionType: "",
      inspectionType: "",
      managers: [],
      specialAttentionNotes: "",
      policyholder: {
        name: ""
      },
      fieldrep: {
        name: "",
        number: ""
      },
      surveyAddress: "",
      surveyCounty: "",
      surveyGeocode: "",
      distanceFromGeocode: "",
      qaQueues: "",
      caseRejections: "",
      appraisalWorkflowStatusType: null,
      caseType: "",
      policyNumber: ""
    },
    photos: {
      photoList: [],
      photoTags: [],
      iframeUrlTemplate: ""
    },
    caseSketch: {
      sketchImages: []
    },
    caseForms: [],
  },
  qaVariables: {
    qaReady: false,
    qaStarted: false,
    qaPaused: false,
    validationErrors: [],
    summaryViewEnabled: false,
    canToggleSummaryView: false,
    keepGettingCases: true,
    showRejectDialog: false,
    showSwitchCaseDialog: false,
    switchCaseDialogControlNum: null,
    showSendToManagerDialog: false,
    showCompleteCaseDialog: false,
    qaSaveDataFunction: () => { },
    timeSpent: null,
    completingCase: false,
    rejectingCase: false,
    escalatingCase: false,
    phoenixRctNeedsCommit: true,
    subscribeToCaseEventMessages: false,
  },
  timeLogByDaySummary: {},
  isFetchingTimeLogByDaySummary: true,
  payPeriodSummary: "",
  fetchingPayPeriodSummary: false,
  specialAttentionNotes: "",
  isFetchingE2: false,
  hasE2Value: false,
  value360: {
    uri: "",
    hasValue: false
  },
  caseRCT: {},
  hasCaseRCT: false,
  requestingCaseRCT: false,
  isFetching360: false,
  managers: [],
  isFetchingManagers: false,
  updatingCaseIssues: false,
  caseHazards: [],
  isFetchingCaseHazards: false,
  isFetchingAssignableUsers: false,
  assignableUsers: [],
};

const quickList = {
  isFetchingQuickListTemplates: false,
  quickListTemplates: [],
  isFetchingQuickLists: false,
  quickLists: [],
  quickListsLoaded: false,
  currentQuicklistId: null,
  currentRowIndex: null,
};

const roleRights = {
  fetchingRoleRights: false,
  requestedRoleRightsEdit: false,
  roleRightsViewModel: null
};

const caseAlerts = [];

const photoTool = {
  selectedPhotoTags: [],
};

const homeownerCustomer = {
  caseInfo: null,
  customerScorecardData: null,
  fetchingAllCustomerActionsForUser: false,
  allCustomerActionsForUser: [],
};

const coreLayoutSettings = {
  headerVisible: true,
  sidebarVisible: true,
};

const customerService = {
  assignToUsers: [],
  isFetchingAssignToUsers: false,
};

const customer = {
  isFetchingAgentList: false,
  agentList: null,
  agentDetails: null,
  isSavingAgent: false,
  majorCompanies: null,
  underwriters: [],
  fetchingUnderwriters: false,
  enabledFeatures: [],
  fetchingEnabledFeatures: false,
  customerList: [],
  fetchingCustomerList: false,
  customerDetails: null,
  fetchingCustomerDetails: false,
  surveyTypeRequirements: null,
  fetchingSurveyTypeRequirements: false,
  selectedSurveyType: null,
  selectedCustomerNumber: null,
  customerFormOptions: [],
  fetchingFormOptions: false,
  notificationTypes: [],
  fetchingNotificationTypes: false,
  notificationMethods: [],
  fetchingNotificationMethods: false,
  notificationLetters: [],
  fetchingNotificationLetters: false,
};

const fieldLevelCoordinators = {
  list: [],
  isFetchingFieldLevelCoordinators: false
};

const caseStepper = {
  fetchingCaseStepper: false,
  trackerActive: true,
  activeStep: -1,
  steps: [],
};

const appraisalPort = {
  onHoldReasons: [],
  isFetchingHoldReasons: false,
};

const caseLinks = {
  caseLinks: [],
  fetchingCaseLinks: false,
};

const riskProfiler = {
  riskProfilerResults: {},
  fetchingRiskProfilerResults: false,
};

const exportTypes = {
  exportTypeResults: [],
  fetchingExportTypes: false,
};

const schedulingAssistant = {
  callCenterReady: false,
  currentControlNumber: null,
};

// TODO: probably should rename this...
// @ts-ignore shouldnt have named something exports, because that gets confused the with the exports of the file
const exports = {
  runningExports: {},
};

const caseAppointment = {
  candidates: [],
  endDate: null,
  fetchingCandidates: false,
  controlNumber: null,
};

export {
  appraisalPort,
  appraiser,
  appraiserManagerAssignRegion,
  assignment,
  broker,
  brokerMaintenanceSettings,
  brokerRegistration,
  caseAlerts,
  caseDetails,
  caseForms,
  caseLinks,
  caseStepper,
  caseTimeLog,
  changeStatus,
  comparable,
  coreLayoutSettings,
  customer,
  customerService,
  dashboard,
  display,
  employee,
  fieldRep,
  fieldLevelCoordinators,
  filters,
  headerDefinitions,
  homeownerCustomer,
  photoTool,
  popoutWindows,
  preferences,
  qaAppraisalRejections,
  qualityAssurance,
  quickList,
  region,
  riskProfiler,
  roleRights,
  search,
  sidebar,
  snackbar,
  twoFactor,
  user,
  validation,
  webOrder,
  exportTypes,
  schedulingAssistant,
  exports,
  caseAppointment,
};

// for some reason we cant just export this variable, it doesnt work the same way with imports, we need to export it how we do above for some reason
const entireInitialState = {
  appraisalPort,
  appraiser,
  appraiserManagerAssignRegion,
  assignment,
  broker,
  brokerMaintenanceSettings,
  brokerRegistration,
  caseAlerts,
  caseDetails,
  caseForms,
  caseLinks,
  caseStepper,
  caseTimeLog,
  changeStatus,
  comparable,
  coreLayoutSettings,
  customer,
  customerService,
  dashboard,
  display,
  employee,
  fieldRep,
  fieldLevelCoordinators,
  filters,
  headerDefinitions,
  homeownerCustomer,
  photoTool,
  popoutWindows,
  preferences,
  qaAppraisalRejections,
  qualityAssurance,
  quickList,
  region,
  riskProfiler,
  roleRights,
  search,
  sidebar,
  snackbar,
  twoFactor,
  user,
  validation,
  webOrder,
  exportTypes,
  schedulingAssistant,
  exports,
  caseAppointment,
};

// use this type when referencing initial state if you want some auto completion
export type InitialState = typeof entireInitialState;
